import api from './axios';

class SalesforceService {
  // Get Salesforce OAuth URL
  async getAuthUrl() {
    try {
      const response = await api.get('/salesforce/auth');
      return response.data.data.authUrl;
    } catch (error) {
      console.error('Error getting Salesforce auth URL:', error);
      throw error;
    }
  }

  // Disconnect Salesforce
  async disconnect() {
    try {
      const response = await api.delete('/salesforce/disconnect');
      return response.data;
    } catch (error) {
      console.error('Error disconnecting Salesforce:', error);
      throw error;
    }
  }

  // Import accounts from Salesforce
  async importAccounts(limit = 100) {
    try {
      const response = await api.get(`/salesforce/import/accounts?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing accounts from Salesforce:', error);
      throw error;
    }
  }

  // Import contacts from Salesforce
  async importContacts(limit = 100) {
    try {
      const response = await api.get(`/salesforce/import/contacts?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing contacts from Salesforce:', error);
      throw error;
    }
  }

  // Import opportunities from Salesforce
  async importOpportunities(limit = 100) {
    try {
      const response = await api.get(`/salesforce/import/opportunities?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing opportunities from Salesforce:', error);
      throw error;
    }
  }
}

const salesforceService = new SalesforceService();
export default salesforceService; 